import React__default from 'react';
import styled from 'styled-components';
import { ComboBoxStateContext } from 'react-aria-components';
import { AkSelectClearIcon } from '@fuegokit/fuegoicons-react';
import Button from '../Button/Button.js';
import Box from '../Box/Box.js';

const StyledClearButton = styled(Button).withConfig({
  displayName: "SelectClearButton__StyledClearButton",
  componentId: "sc-vt23g6-0"
})(["all:unset;outline:revert;display:flex;align-items:center;"]);
const ClearButton = () => {
  const state = React__default.useContext(ComboBoxStateContext);
  return /*#__PURE__*/React__default.createElement(StyledClearButton
  // Don't inherit default Button behavior from Combobox.
  , {
    slot: null,
    className: "clear-button",
    "aria-label": "Clear",
    onPress: () => state.setSelectedKey(null),
    "data-testid": "select-clear-button"
  }, /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      color: 'icon.subtle',
      ':hover': {
        color: 'icon.default'
      }
    }
  }, /*#__PURE__*/React__default.createElement(AkSelectClearIcon, {
    size: 16
  })));
};
ClearButton.displayName = "ClearButton";
var SelectClearButton = ClearButton;

export { StyledClearButton, SelectClearButton as default };
